import React from 'react';

import { UTCDate } from '@date-fns/utc';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TimeField } from '@mui/x-date-pickers/TimeField';

const TimePicker = ({ name, value, onChange, refDate, inMinutes, ...props }) => {

	const handleChange = t => {
		const time = t?.getTime();
		let v;

		if (inMinutes) {
			v = (!t || Number.isNaN(time)) ? null : (t.getHours() * 60 + t.getMinutes());
		} else {
			v = (!t || Number.isNaN(time)) ? null : t;
		}
		onChange({ target: { name, value: v } });
	};

	const v = inMinutes ? new Date(0) : value;
	if (inMinutes) {
		const h = Math.floor(value / 60);
		const m = Math.round(value - (h * 60));
		v.setHours(h);
		v.setMinutes(m);
	}

	return (
		<LocalizationProvider dateAdapter={AdapterDateFns}>
			<TimeField
				value={v}
				onChange={handleChange}
				referenceDate={refDate || new UTCDate(0)}
				format="HH:mm"
				fullWidth
				sx={{ marginBottom: 2 }}
				// timezone="UTC"
				{...props}
			/>
		</LocalizationProvider>
	);
};


TimePicker.type = 'TimePicker';
TimePicker.spec = [{
	name: 'TimePicker',
	key: 'TimePicker',
	title: 'Time',
	icon: 'Clock',
	category: 'input',
	translatable: ['label'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}],
}];


export default TimePicker;